import axios from 'axios';
import { createAppAsyncThunk } from '../appAsyncThunk';
import { get, post } from 'aws-amplify/api';
import { GetMultipleChoiceExam } from './types';

export const getMultipleChoiceExamDetailThunk = createAppAsyncThunk(
    'exam/getMultipleChoiceExamDetailThunk', async (params: GetMultipleChoiceExam) => {
        const restOperation = await get({
            apiName: 'exam',
            path: '/exam/{proxy+}',
            options: { queryParams: { ...params } },
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const getMultipleChoiceExamQuestionThunk = createAppAsyncThunk(
    'exam/getMultipleChoiceExamQuestionThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'exam',
            path: '/exam/{proxy+}',
            options: { body },
        }).response;

        const responseBody = await restOperation.body.json();

        const response = {
            body: responseBody,
            statusCode: restOperation.statusCode,
        }

        return response as any;
    });

export const setExamAnswersThunk = createAppAsyncThunk(
    'exam/setExamAnswersThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'score',
            path: '/score/{proxy+}',
            options: { body }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

// export const kycThunk = createAppAsyncThunk(
//     'exam/kycThunk', async (body: any) => {
//         const restOperation = await post({
//             apiName: 'kyc',
//             path: '/kyc/{proxy+}',
//             options: { body }
//         }).response;

//         const response = await restOperation.body.json();
//         return response as any;
//     });

export const kycThunk = createAppAsyncThunk(
    'exam/kycThunk',
    async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'kyc',
                path: '/kyc/{proxy+}',
                options: { body },
            }).response;

            const response = await restOperation.body.json();
            return response;
        } catch (error: any) {
            let apiError = null;

            try {
                if (error?._response?.body) {
                    apiError = JSON.parse(error._response.body);
                }
            } catch { }

            return rejectWithValue(apiError || 'Something went wrong. Please try again');
        }
    }
);



export const getCodingExamQuestionThunk = createAppAsyncThunk(
    'exam/getCodingExamQuestionThunk', async (body: any) => {

        const restOperation = await post({
            apiName: 'codingExam',
            path: '/codingExam/{proxy+}',
            options: { body }
        }).response;

        const responseBody = await restOperation.body.json();

        const response = {
            body: responseBody,
            statusCode: restOperation.statusCode,
        }

        return response as any;
    });

// export const getCodingExamQuestionThunk = createAppAsyncThunk(
//     'exam/getCodingExamQuestionThunk', async (body: any, { rejectWithValue }) => {
//         try {

//             const restOperation = await post({
//                 apiName: 'codingExam',
//                 path: '/codingExam/{proxy+}',
//                 options: { body }
//             }).response;

//             const response = await restOperation.body.json();
//             return response as any;
//         } catch (e: unknown) {
//             if (e instanceof Error) {
//                 return rejectWithValue(e.message);
//             } else {
//                 return rejectWithValue('Somthing went wrong. Please try again');
//             }
//         }
//     });

export const postCodingExamAnswerThunk = createAppAsyncThunk(
    'exam/postCodingExamAnswerThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'codingScore',
            path: '/codingScore/{proxy+}',
            options: { body }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const proctoringThunk = createAppAsyncThunk(
    'exam/proctoringThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'proctoring',
            path: '/proctoring/{proxy+}',
            options: { body }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const runCodeEditorSnippetThunk = createAppAsyncThunk(
    'exam/runCodeEditorSnippetThunk', async (body: any, { rejectWithValue }) => {
        try {
            const response = await axios.post('https://onecompiler-apis.p.rapidapi.com/api/v1/run', body, {
                headers: {
                    'x-rapidapi-key': '8c4371ce86mshc3bbcce3d346162p10eb16jsncc6a5448226f',
                    'x-rapidapi-host': 'onecompiler-apis.p.rapidapi.com',
                    'Content-Type': 'application/json',
                }
            })

            return response.data.stdout || response.data.stderr || 'Program did not output anything!';
        } catch (e: unknown) {
            return rejectWithValue('Somthing went wrong. Please try again');
        }
    });

export const getRecruitingInterviewDataThunk = createAppAsyncThunk(
    'exam/getRecruitingInterviewDataThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'interviewExam',
            path: '/interviewExam/{proxy+}',
            options: { body }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const scoreRecruitingInterviewThunk = createAppAsyncThunk(
    'exam/scoreRecruitingInterviewThunk', async (body: any) => {
        const restOperation = await post({
            apiName: 'interviewScore',
            path: '/interviewScore/{proxy+}',
            options: { body }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });